import { render, staticRenderFns } from "./UserGroupSelectionField.vue?vue&type=template&id=8efb7ac6&scoped=true"
import script from "./UserGroupSelectionField.vue?vue&type=script&lang=js"
export * from "./UserGroupSelectionField.vue?vue&type=script&lang=js"
import style0 from "./UserGroupSelectionField.vue?vue&type=style&index=0&id=8efb7ac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efb7ac6",
  null
  
)

export default component.exports